import { faqItems } from '@/mocks/homepage';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          关于网红爆料平台的常见疑问，这里都有答案
        </p>
        <div className="max-w-3xl mx-auto grid gap-4">
          {faqItems.map((item) => (
            <details
              key={item.id}
              className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-6 py-5 text-sm md:text-base font-medium text-foreground-800 list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">{item.question}</h3>
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                </div>
              </summary>
              <div className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}